import { Task } from "@/api/mutation/useTaskCreateMutation";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Scheduler, SchedulerEvent } from "smart-webcomponents-react/scheduler";
import "./index.css";
import Dialog from "@/components/common/Dialog";
import TrashCan from "../../../assets/svg/TrashCan.svg";
import { Button } from "@/components/ui/button";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import { toast } from "react-toastify";
import { errorConfig } from "@/lib/toastError";
import {
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import ReactDOMServer from "react-dom/server";
import { useUser } from "@/hooks/useUser";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import ReactDOM from "react-dom";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
import { useOutsideClick } from "@/helperFuntions/clickOutsideHook";

function CalendarView(props: { data: Task[]; refetch: () => void }) {
  const { t, i18n } = useTranslation();

  const { projectId } = useParams();
  const removeTaskMutation = useRemoveTaskMutation();
  const projectDetailQuery = useProjectDetail(projectId ?? "");
  const contextMenuRef = useRef<HTMLDivElement>(null);
  const [dataSource, setDataSource] = useState<SchedulerEvent[]>();
  const { user } = useUser();
  const [dialogRendered, setDialogRendered] = useState<string | undefined>(
    undefined
  );
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null
  );
  const [isTaskShow, setIsTaskShow] = useState<boolean>(false);
  const [contextMenuOption, setContextMenuOption] = useState<{
    contextMenuPosition: { x: number; y: number };
    contextMenuVisible: boolean;
    contextMenuTaskId: string | null;
    allowedMethods: ("edit" | "delete" | "create")[];
    clickedDate: Date | null;
      }>({
        contextMenuPosition: { x: 0, y: 0 },
        contextMenuVisible: false,
        contextMenuTaskId: null,
        allowedMethods: [],
        clickedDate: null,
      });
  const organisationRole = useMemo(() => {
    return user?.userOrganisation[0].role;
  }, [user]);
  const projectRole = useMemo(() => {
    const project = projectDetailQuery.data?.data.data;
    return project?.assignedUsers.find(
      (projectUser) => projectUser.user.userId == user?.userId
    )?.projectRole as keyof typeof UserRoleEnumValue;
  }, [projectDetailQuery.data?.data.data, user]);
  const allowed = useCallback(
    (taskId: string | null) => {
      const allowedActions: ("edit" | "delete" | "create")[] = [];
      if (!taskId) {
        if (  projectRole !== UserRoleEnumValue.COLLABORATOR) {
          allowedActions.push("create");
        }
      } else {
        const task = props.data.find((task) => task.taskId == taskId);
        if (
          (task && organisationRole == UserRoleEnumValue.ADMINISTRATOR) ||
          projectRole == UserRoleEnumValue.PROJECT_MANAGER ||
          projectRole == UserRoleEnumValue.ADMINISTRATOR
        ) {
          allowedActions.push("edit", "delete");
        } else if (
          task &&
          projectRole == UserRoleEnumValue.TEAM_MEMBER &&
          task.createdByUserId == user?.userId
        ) {
          allowedActions.push("edit", "delete");
        } else if (
          task &&
          (projectRole == UserRoleEnumValue.TEAM_MEMBER) &&
          task.assignedUsers.find(
            (taskUser) => taskUser.user.userId == user?.userId
          )
        ) {
          allowedActions.push("edit");
        }else if (
          projectRole == UserRoleEnumValue.COLLABORATOR
        ){
          allowedActions.push("edit");
        }
        return allowedActions;
      }
      return allowedActions;
    },
    [props.data, organisationRole, projectRole, user?.userId]
  );
  const closeContextMenu = useCallback(() => {
    setContextMenuOption({
      allowedMethods: [],
      contextMenuPosition: { x: 0, y: 0 },
      contextMenuTaskId: null,
      contextMenuVisible: false,
      clickedDate: null,
    });
  }, []);

  useOutsideClick(contextMenuRef, closeContextMenu); // Hook to close menu on outside click

  const scheduler = useRef<Scheduler | null>(null);
  useEffect(() => {
    setDataSource(
      props.data.map((d) => {
        return DataConvertToScheduler(d);
      })
    );
  }, [props.data]);

  const DataConvertToScheduler = (task: Task): SchedulerEvent => {
    return {
      id: task.taskId,
      status: task.status,
      dateStart: task.startDate,
      dateEnd:
        task.milestoneIndicator && task.dueDate
          ? new Date(task.dueDate)
          : new Date(task.endDate),
      label: task.taskName,
      description: task.taskDescription,
      backgroundColor:
        task.status == TaskStatusEnumValue.NOT_STARTED
          ? "#787486"
          : task.status == TaskStatusEnumValue.IN_PROGRESS
            ? "#306BFF"
            : task.status == TaskStatusEnumValue.COMPLETED
              ? "#68B266"
              : "#888888",
      color: "#fff",
      class: "!text-white",
      disableDrag: true,
      disableResize: true,
    };
  };
  const days = [
    { lable: "SUN", value: 0 },
    { lable: "MON", value: 1 },
    { lable: "TUE", value: 2 },
    { lable: "WED", value: 3 },
    { lable: "THU", value: 4 },
    { lable: "FRI", value: 5 },
    { lable: "SAT", value: 6 },
  ];
  const nonWorkingDays = () => {
    const nonworkingDays: (number | undefined)[] = [];
    user?.userOrganisation[0].organisation.nonWorkingDays.forEach((day) => {
      if (day) {
        nonworkingDays.push(days.find((d) => d.lable == day)?.value);
      }
    });
    return nonworkingDays;
  };
  const onItemClick = (e: (Event & CustomEvent) | undefined) => {
    e?.preventDefault();
    if (projectRole !== UserRoleEnumValue.COLLABORATOR) {
      if (!e?.detail.item.id) {
        setDialogRendered(undefined), setIsTaskShow(true);
        setContextMenuOption((prev) => ({
          ...prev,
          clickedDate: e?.detail.item.dateStart,
        }));
      } else {
        setDialogRendered(e?.detail.item.id);
      }
    }
  };
  const close = () => {
    props.refetch();
    setDialogRendered(undefined);
    setIsTaskShow(false);
    setContextMenuOption({
      allowedMethods: [],
      contextMenuPosition: { x: 0, y: 0 },
      contextMenuTaskId: null,
      contextMenuVisible: false,
      clickedDate: null,
    });
  };
  const removeTask = () => {
    if (showConfirmDelete) {
      removeTaskMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          setShowConfirmDelete(null);
          props.refetch();
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };

  const headerTemplate = (date: Date) => {
    const currentDate = new Date(date);
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dayOfWeek = daysOfWeek[currentDate.getDay()];
    const nonWorkingDay = nonWorkingDays(); //[0,6]
    return ReactDOMServer.renderToString(
      <div
        className={`flex justify-start p-1 px-3  text-white items-center h-full w-full ${
          nonWorkingDay.includes(daysOfWeek.indexOf(dayOfWeek))
            ? " bg-primary-500/15 !text-red-400"
            : "bg-primary-500"
        }`}
      >
        {t(dayOfWeek)}
      </div>
    );

    // return
  };

  const eventCollectorTemplate = (elemet: Element, data: any[]) => {
    elemet.textContent = `${t("view")} ${data.length} ${t("more")}`;
    elemet.classList.add("!text-xs");
    elemet.classList.add("!font-semibold");
    elemet.classList.add("!p-1");
    elemet.classList.add("!w-fit");
    elemet.classList.add("!underline");
    elemet.classList.add("!text-primary-500");
    elemet.classList.add("!text-primary-500");
    elemet.classList.add("!bg-transparent");
    return elemet;
  };
  const cellTemplate = (cell: HTMLElement, date: Date) => {
    const cellDate = date.getDate();
    cell.textContent = "";

    if (cellDate === 1 && scheduler?.current) {
      cell.innerHTML = new Intl.DateTimeFormat(scheduler?.current.locale, {
        month: "short",
        day: scheduler?.current.dayFormat as "numeric" | "2-digit" | undefined,
      }).format(date);
    } else {
      cell.innerHTML = cellDate + "";
    }

    const dayOfWeek = new Date(date).getDay();
    const holiday = user?.userOrganisation[0].organisation.orgHolidays?.find(
      (d) => {
        const startDate = new Date(d.holidayStartDate);

        if (d.holidayEndDate) {
          const endDate = new Date(d.holidayEndDate);
          return new Date(date) >= startDate && new Date(date) <= endDate;
        } else {
          return (
            new Date(date).toLocaleDateString() ==
            startDate.toLocaleDateString()
          );
        }
      }
    );
    const htmlObject = document.createElement("div");
    if (holiday) {
      cell.classList.add("!bg-primary-200/30");
      cell.classList.add("!text-rose-300");
      cell.classList.add("!text-right");
      ReactDOM.render(
        tooltipRender(cellDate, holiday.holidayReason),
        htmlObject
      );
      cell.innerHTML = htmlObject.innerHTML;
      cell.setAttribute("holiday-name", holiday.holidayReason);
    } else if (nonWorkingDays().includes(dayOfWeek)) {
      cell.classList.add("!bg-primary-200/30");
      cell.classList.add("!text-rose-300");
    } else {
      cell.classList.remove("!bg-primary-200/30");
      cell.classList.remove("!text-rose-300");
    }
    return cell;
  };

  const tooltipRender = (cellDate: number, text: string) => {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="text-sm cursor-pointer grow line-clamp-1 flex items-center justify-end gap-2">
              <p className="w-28 truncate text-xs"> {text} </p>
              {cellDate}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p className="text-sm"> {text}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  };

  return (
    <>
      <div className="h-full flex flex-col gap-2">
        {/* <TaskFilter
            ref={filterRef}
            fieldToShow={[
              FIELDS.ASSIGNED,
              FIELDS.DATE,
              FIELDS.DUESEVENDAYS,
              FIELDS.FLAGS,
              FIELDS.OVERDUEDAYS,
              FIELDS.TODAYDUEDAYS,
            ]}
            tasks={props.data}
            filteredData={(task) => setprops.data(task)}
          /> */}
        {projectId && (
          <Scheduler
            ref={scheduler}
            key={dataSource + ""}
            id="scheduler"
            dataSource={dataSource}
            view="month"
            eventCollectorTemplate={eventCollectorTemplate}
            // nonworkingDays={nonWorkingDays()}
            draggable={false}
            // hideNonworkingWeekdays={true}
            className="!h-full scheduler"
            cellTemplate={cellTemplate}
            timelineHeaderFormatFunction={headerTemplate}
            locale={i18n.language}
            onEditDialogOpening={(e) =>
              onItemClick(e as (Event & CustomEvent) | undefined)
            }
            onContextMenuOpening={(e) => {
              const event = e as CustomEvent & Event;
              e?.preventDefault();
              e?.stopPropagation();
              event.stopImmediatePropagation();

              const x = event.detail?.target?.offsetLeft || 0;
              const y = event.detail?.target?.offsetTop || 0;
              const allowedAction = allowed(
                event.detail?.eventObj?.[0]?.id ?? null
              );
              if (allowedAction.length == 0) {
                setContextMenuOption({
                  contextMenuPosition: {
                    x: 0,
                    y: 0,
                  },
                  contextMenuVisible: false,
                  contextMenuTaskId: null,
                  allowedMethods: [],
                  clickedDate: null,
                });
              } else {
                setContextMenuOption({
                  contextMenuPosition: {
                    x,
                    y,
                  },
                  contextMenuVisible: true,
                  contextMenuTaskId: event.detail?.eventObj?.[0]?.id || null,
                  allowedMethods: allowedAction,
                  clickedDate:
                      event.detail?.eventObj?.[0]?.dateStart ??
                      event.detail?.cellObj?.date ??
                      null,
                });
              }
            }}
            messages={{
              [i18n.language]: i18n.getDataByLanguage(i18n.language)
                ?.translations,
            }}
          ></Scheduler>
        )}
        {(dialogRendered || isTaskShow) && (
          <TaskSubTaskForm
            close={close}
            taskId={dialogRendered ?? undefined}
            projectId={projectId}
            initialValues={{
              startDate: contextMenuOption.clickedDate ?? undefined,
            }}
          />
        )}
      </div>
      {contextMenuOption.contextMenuVisible && (
        <div
          ref={contextMenuRef} // Assign ref
          style={{
            position: "fixed", // Use fixed positioning relative to viewport
            top: `${contextMenuOption.contextMenuPosition.y}px`,
            left: `${contextMenuOption.contextMenuPosition.x}px`,
            zIndex: 50, // Ensure it's above other elements
          }}
          className="bg-white border border-gray-300 rounded-md shadow-lg py-1 min-w-[80px]"
          onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing it immediately
          onContextMenu={(e) => e.preventDefault()} // Prevent context menu from showing
        >
          {contextMenuOption.allowedMethods.includes("edit") && (
            <div
              className="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setDialogRendered(
                  contextMenuOption.contextMenuTaskId ?? undefined
                );
                closeContextMenu();
              }}
            >
              {t("Edit")}
            </div>
          )}
          {contextMenuOption.allowedMethods.includes("delete") && (
            <div
              className="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer text-red-600"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setShowConfirmDelete(contextMenuOption.contextMenuTaskId);
                closeContextMenu();
              }}
            >
              {t("Delete")}
            </div>
          )}
          {contextMenuOption.allowedMethods.includes("create") && (
            <div
              className="px-3 py-1.5 text-sm hover:bg-gray-100 cursor-pointer"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setDialogRendered(undefined), setIsTaskShow(true);
                closeContextMenu();
              }}
            >
              {t("Create")}
            </div>
          )}
        </div>
      )}
      <Dialog
        isOpen={Boolean(showConfirmDelete)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
              onClick={() => setShowConfirmDelete(null)}
            >
              Cancel
            </Button>
            <Button
              variant={"primary"}
              onClick={removeTask}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
            >
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default CalendarView;
